import React from 'react';
import './my-transfers.scss';

import Transfers from '../transfers/transfers';

const MyTransfers = () => {
  return <Transfers />;
};

export default MyTransfers;
